const API_AUTH_USERNAME = "grampanchayat";
const API_AUTH_PASSWORD = "t5AK6/mFx[`7chzJ";
const ADMIN_ID = "1";
const API_BASE_URL = "https://microdynamicsoftware.uk/gram_panchayat_website/";
export { API_AUTH_USERNAME, API_AUTH_PASSWORD, API_BASE_URL, ADMIN_ID };
